"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var site_variables_1 = require("../teams-v2/site-variables");
var constants_1 = require("../constants");
/**
 * Site variable overrides for the TFW 2 dark theme
 */
exports.default = {
    theme: constants_1.TeamsTheme.Dark,
    colors: site_variables_1.colorPaletteV2,
    colorScheme: {
        elevations: {
            2: "0px 0.8px 1.8px rgba(0, 0, 0, 0.32), 0px 0.15px 0.45px rgba(0, 0, 0, 0.28)",
            4: "0px 1.6px 3.6px rgba(0, 0, 0, 0.28), 0px 0.3px 0.9px rgba(0, 0, 0, 0.32)",
            8: "0px 3.2px 7.2px rgba(0, 0, 0, 0.32), 0px 0.6px 1.8px rgba(0, 0, 0, 0.28)",
            16: "0px 6.4px 14.4px rgba(0, 0, 0, 0.32), 0px 1.2px 3.6px rgba(0, 0, 0, 0.28)",
            32: "0px 12.8px 28.8px rgba(0, 0, 0, 0.32), 0px 2.4px 7.2px rgba(0, 0, 0, 0.28)",
            64: "0px 25.6px 57.6px rgba(0, 0, 0, 0.32), 0px 4.8px 14.4px rgba(0, 0, 0, 0.28)",
        },
        default: {
            foreground: site_variables_1.colorPaletteV2.white,
            foreground1: site_variables_1.colorPaletteV2.grey["220"],
            foreground2: site_variables_1.colorPaletteV2.grey["310"],
            foreground3: site_variables_1.colorPaletteV2.white,
            foreground4: site_variables_1.colorPaletteV2.white,
            background: site_variables_1.colorPaletteV2.grey["700"],
            background1: site_variables_1.colorPaletteV2.grey["750"],
            background2: site_variables_1.colorPaletteV2.grey["800"],
            background3: site_variables_1.colorPaletteV2.grey["870"],
            background4: site_variables_1.colorPaletteV2.grey["550"],
            background5: site_variables_1.colorPaletteV2.grey["600"],
            border: site_variables_1.colorPaletteV2.grey["450"],
            border1: site_variables_1.colorPaletteV2.grey["850"],
            border2: site_variables_1.colorPaletteV2.grey["900"],
            border3: site_variables_1.colorPaletteV2.grey["550"],
            foregroundHover: site_variables_1.colorPaletteV2.white,
            foregroundHover1: site_variables_1.colorPaletteV2.white,
            foregroundHover2: site_variables_1.colorPaletteV2.white,
            backgroundHover: site_variables_1.colorPaletteV2.grey["550"],
            backgroundHover1: site_variables_1.colorPaletteV2.grey["750"],
            backgroundHover2: "transparent",
            backgroundHover3: site_variables_1.colorPaletteV2.grey["650"],
            backgroundHover4: site_variables_1.colorPaletteV2.grey["750"],
            backgroundHover6: site_variables_1.colorPaletteV2.grey["550"],
            borderHover: site_variables_1.colorPaletteV2.grey["430"],
            foregroundPressed: site_variables_1.colorPaletteV2.white,
            backgroundPressed: site_variables_1.colorPaletteV2.grey["650"],
            foregroundActive: site_variables_1.colorPaletteV2.white,
            foregroundActive1: site_variables_1.colorPaletteV2.white,
            backgroundActive: site_variables_1.colorPaletteV2.grey["600"],
            backgroundActive1: site_variables_1.colorPaletteV2.grey["800"],
            borderActive: site_variables_1.colorPaletteV2.grey["440"],
            // foregroundFocus: not specified,
            // backgroundFocus: not specified,
            borderFocus: site_variables_1.colorPaletteV2.white,
            borderFocusWithin: site_variables_1.colorPaletteV2.black,
            foregroundDisabled: site_variables_1.colorPaletteV2.grey["460"],
            foregroundDisabled1: site_variables_1.colorPaletteV2.grey["460"],
            borderDisabled: site_variables_1.colorPaletteV2.grey["500"],
            backgroundDisabled: site_variables_1.colorPaletteV2.grey["800"],
            backgroundDisabled1: site_variables_1.colorPaletteV2.grey["800"],
        },
        brand: {
            background: site_variables_1.colorPaletteV2.brand["600"],
            background1: site_variables_1.colorPaletteV2.brand["1000"],
            background2: site_variables_1.colorPaletteV2.brand["900"],
            background3: site_variables_1.colorPaletteV2.brand["1000"],
            background4: site_variables_1.colorPaletteV2.grey["910"],
            foreground: site_variables_1.colorPaletteV2.brand["450"],
            foreground1: site_variables_1.colorPaletteV2.brand["450"],
            foreground2: site_variables_1.colorPaletteV2.brand["450"],
            foreground3: site_variables_1.colorPaletteV2.brand["200"],
            foreground4: site_variables_1.colorPaletteV2.white,
            border: site_variables_1.colorPaletteV2.grey["450"],
            border1: site_variables_1.colorPaletteV2.brand["800"],
            border2: site_variables_1.colorPaletteV2.brand["800"],
            foregroundHover: site_variables_1.colorPaletteV2.brand["450"],
            foregroundHover1: site_variables_1.colorPaletteV2.white,
            foregroundHover2: site_variables_1.colorPaletteV2.brand["200"],
            borderHover: site_variables_1.colorPaletteV2.brand["600"],
            backgroundHover: site_variables_1.colorPaletteV2.brand["700"],
            backgroundHover1: site_variables_1.colorPaletteV2.brand["900"],
            foregroundPressed: site_variables_1.colorPaletteV2.brand["200"],
            foregroundPressed1: site_variables_1.colorPaletteV2.white,
            backgroundPressed: site_variables_1.colorPaletteV2.brand["800"],
            borderPressed: site_variables_1.colorPaletteV2.brand["800"],
            foregroundActive: site_variables_1.colorPaletteV2.brand["450"],
            foregroundActive1: site_variables_1.colorPaletteV2.brand["450"],
            foregroundActive2: site_variables_1.colorPaletteV2.brand["50"],
            backgroundActive: site_variables_1.colorPaletteV2.brand["450"],
            backgroundActive1: site_variables_1.colorPaletteV2.brand["450"],
            borderActive: site_variables_1.colorPaletteV2.grey["450"],
            borderActive1: site_variables_1.colorPaletteV2.brand["800"],
            borderActive2: site_variables_1.colorPaletteV2.brand["800"],
            foregroundFocus: site_variables_1.colorPaletteV2.brand["450"],
            foregroundFocus1: site_variables_1.colorPaletteV2.brand["450"],
            foregroundFocus2: site_variables_1.colorPaletteV2.brand["450"],
            foregroundFocus3: site_variables_1.colorPaletteV2.brand["50"],
            foregroundFocus4: site_variables_1.colorPaletteV2.white,
            backgroundFocus: site_variables_1.colorPaletteV2.brand["450"],
            backgroundFocus1: site_variables_1.colorPaletteV2.brand["1000"],
            backgroundFocus2: site_variables_1.colorPaletteV2.brand["900"],
            backgroundFocus3: site_variables_1.colorPaletteV2.brand["1000"],
            borderFocus: site_variables_1.colorPaletteV2.white,
            borderFocus1: site_variables_1.colorPaletteV2.brand["450"],
            borderFocusWithin: site_variables_1.colorPaletteV2.black,
            foregroundDisabled: site_variables_1.colorPaletteV2.grey["460"],
            foregroundDisabled1: site_variables_1.colorPaletteV2.grey["460"],
            borderDisabled: site_variables_1.colorPaletteV2.grey["500"],
            backgroundDisabled: site_variables_1.colorPaletteV2.grey["800"],
            backgroundDisabled1: site_variables_1.colorPaletteV2.grey["800"],
        },
    },
};
//# sourceMappingURL=site-variables.js.map